module.exports = __webpack_public_path__ + "img/gouxuan.477eeed6.svg";